module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-more"
  }, [_c('transition', {
    attrs: {
      "name": "lxm-transition-fade",
      "mode": "out-in"
    }
  }, [(_vm.loading) ? [_c('animation', {
    attrs: {
      "canvasStyle": {
        width: '2.85rem',
        height: '2.85rem'
      }
    }
  })] : (!_vm.pureLoading) ? [_c('div', {
    staticClass: "lxm-more__button",
    on: {
      "click": _vm.clicked
    }
  }, [_vm._v("加载更多")])] : _vm._e()], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-752360d6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-752360d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmMore.vue
// module id = 868
// module chunks = 0